import axios from 'axios';
import { config } from './host';
import toast, { Toaster } from 'react-hot-toast';
import { Auth } from '../utils/Auth';
import Cookies from "js-cookie";

// Buat instance axios
const api = axios.create({
    baseURL: config.apiHostGw,
    // timeout: 25000,
});

// Tambah interceptor untuk token
api.interceptors.request.use(
    function (config) {
        const token = Cookies.get("token");
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // config.headers.Accept = 'application/json';
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Interceptor response untuk menangani 401 Unauthorized
api.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        console.log(error.response.data);
        
        if (error.response && error.response.status === 401 && error.response.data.summary.includes('Unauthorized')) {
            toast.error('Session Sudah Habis Mohon untuk login kembali');
            Auth.logout();
        }

        return Promise.reject(error);
    }
);

export default api;
